import { TFunction } from "i18next";

import {
  EndMarketRole,
  MaterialGroup,
  MaterialUnit,
} from "fe-shared/src/types/domain";
import { MaterialFormContent } from "./validation";

import styles from "../EditDispositionDialog.module.scss";

export const getEndMarketRoleCodeOptions = (t: TFunction) =>
  Object.values(EndMarketRole).map((id) => ({
    value: id,
    label: t(`businessRoles.${id}`),
  }));

export const getInputConfig = (
  prefix: string,
  index: number,
  title: string,
  isWeightInput: boolean
) => ({
  valueKey: `${prefix}[${index}].units.unitQuantity`,
  componentProps: {
    title,
    width: "102px",
    wrapperClassName: styles.quantityInput,
    messageClassName: styles.quantityInputMessage,
  },
});

export const getMaterialsInputConfig = (
  prefix: string,
  materialsByCode: {
    [key: string]: {
      name: string;
    };
  },
  group: MaterialGroup<MaterialFormContent>
) =>
  group.items.map(({ materialCode }, index) =>
    getInputConfig(
      prefix,
      index,
      materialsByCode[materialCode]?.name,
      group.unit === MaterialUnit.Kg
    )
  );
